module.exports = __webpack_public_path__ + "static/media/Parallel edges.79d0ef12.svg";